import React from 'react';
import Phaser from 'phaser';
import { IonPhaser } from '@ion-phaser/react';
import styles from './scenes.module.scss';
import { throttle } from '../../utils/utils';
import ismobilejs from 'ismobilejs';
import { withRouter } from 'react-router-dom';
import Button from '../Common/Button';
import { connect } from 'react-redux';
import common from '../../common/common';
import { Commun } from '../../utils/axios';
import intl from "react-intl-universal";


import SpriteJson from '../../assets/img/phaser/sprite.json';
import BottleJson from '../../assets/img/phaser/bottle.json';
import Img from '../../assets/img/phaser/sprite.png';

import lottie from 'lottie-web';
import medal01Json from '../../assets/lottie/medal01.json';
import medal02Json from '../../assets/lottie/medal02.json';
import medal03Json from '../../assets/lottie/medal03.json';
import medal04Json from '../../assets/lottie/medal04.json';
import medal05Json from '../../assets/lottie/medal05.json';
import medal06Json from '../../assets/lottie/medal06.json';
import medal07Json from '../../assets/lottie/medal07.json';
import medal08Json from '../../assets/lottie/medal08.json';
import medal09Json from '../../assets/lottie/medal09.json';
import medal10Json from '../../assets/lottie/medal10.json';
import whiteMeteorJson from '../../assets/lottie/whiteMeteor.json';
import backParticleJson from '../../assets/lottie/backParticle.json';
import backgroundJson from '../../assets/lottie/background.json';
import explodeJson from '../../assets/lottie/explode.json';
import roomboxComingJson from '../../assets/lottie/roomboxComing.json';
import uploadAniData from '../../assets/lottie/upload.json';

import AlloyFinger from 'alloyfinger/react/AlloyFinger';
import store from '../../store';

const changeImgOrigin = (target, index) => {
  target.assets.forEach((item, subIndex) => {
    item.u && (item.u = '');
    if (index === 0) {
      item.p && (item.p = require(`../../assets/lottieImg/medal01Json/img_${subIndex}.png`));
    }
    if (index === 1) {
      item.p && (item.p = require(`../../assets/lottieImg/medal02Json/img_${subIndex}.png`));
    }
    if (index === 2) {
      item.p && (item.p = require(`../../assets/lottieImg/medal03Json/img_${subIndex}.png`));
    }
    if (index === 3) {
      item.p && (item.p = require(`../../assets/lottieImg/medal04Json/img_${subIndex}.png`));
    }
    if (index === 4) {
      item.p && (item.p = require(`../../assets/lottieImg/medal05Json/img_${subIndex}.png`));
    }
    if (index === 5) {
      item.p && (item.p = require(`../../assets/lottieImg/medal06Json/img_${subIndex}.png`));
    }
    if (index === 6) {
      item.p && (item.p = require(`../../assets/lottieImg/medal07Json/img_${subIndex}.png`));
    }
    if (index === 7) {
      item.p && (item.p = require(`../../assets/lottieImg/medal08Json/img_${subIndex}.png`));
    }
    if (index === 8) {
      item.p && (item.p = require(`../../assets/lottieImg/medal09Json/img_${subIndex}.png`));
    }
    if (index === 9) {
      item.p && (item.p = require(`../../assets/lottieImg/medal10Json/img_${subIndex}.png`));
    }
    if (index === 10) {
      item.p && (item.p = require(`../../assets/lottieImg/whiteMeteorJson/img_${subIndex}.png`));
    }
    if (index === 11) {
      item.p && (item.p = require(`../../assets/lottieImg/backgroundJson/img_${subIndex}.png`));
    }
    if (index === 12) {
      item.p && (item.p = require(`../../assets/lottieImg/explodeJson/img_${subIndex}.png`));
    }
    if (index === 13) {
      item.p && (item.p = require(`../../assets/lottieImg/roomboxComingJson/img_${subIndex}.png`));
    }
    if (index === 14) {
      item.p && (item.p = require(`../../assets/lottieImg/uploadJson/img_${subIndex}.png`));
    }
  })
}

const jsonArr = [medal01Json, medal02Json, medal03Json, medal04Json, medal05Json, medal06Json, medal07Json, medal08Json, medal09Json, medal10Json, whiteMeteorJson, backgroundJson, explodeJson, roomboxComingJson, uploadAniData];
jsonArr.forEach((t, index) => {
  changeImgOrigin(t, index);
})



const isMobileJs = ismobilejs();
// isMobileJs.tablet
const isMobile = isMobileJs.any;

const config = {
  width: 211,
  height: 260,
  0: medal01Json,
  1: medal02Json,
  2: medal03Json,
  3: medal04Json,
  4: medal05Json,
  5: medal06Json,
  6: medal07Json,
  7: medal08Json,
  8: medal09Json,
  9: medal10Json,
  'ball0': 'star-ball_01',
  'ball1': 'star-ball_02',
  'ball2': 'star-ball_03',
  'ball3': 'star-ball_04',
  'ball4': 'star-ball_05',
  'ball5': 'star-ball_06',
  'ball6': 'star-ball_07',
  'ball7': 'star-ball_08',
  'ball8': 'star-ball_09',
  'ball9': 'star-ball_10',
  'imgBall0': require('../../assets/img/star/star-ball_01.png'),
  'imgBall1': require('../../assets/img/star/star-ball_02.png'),
  'imgBall2': require('../../assets/img/star/star-ball_03.png'),
  'imgBall3': require('../../assets/img/star/star-ball_04.png'),
  'imgBall4': require('../../assets/img/star/star-ball_05.png'),
  'imgBall5': require('../../assets/img/star/star-ball_06.png'),
  'imgBall6': require('../../assets/img/star/star-ball_07.png'),
  'imgBall7': require('../../assets/img/star/star-ball_08.png'),
  'imgBall8': require('../../assets/img/star/star-ball_09.png'),
  'imgBall9': require('../../assets/img/star/star-ball_10.png'),
  'imgMedal0': require('../../assets/img/star/xz01_grey.png'),
  'imgMedal1': require('../../assets/img/star/xz02_grey.png'),
  'imgMedal2': require('../../assets/img/star/xz03_grey.png'),
  'imgMedal3': require('../../assets/img/star/xz04_grey.png'),
  'imgMedal4': require('../../assets/img/star/xz05_grey.png'),
  'imgMedal5': require('../../assets/img/star/xz06_grey.png'),
  'imgMedal6': require('../../assets/img/star/xz07_grey.png'),
  'imgMedal7': require('../../assets/img/star/xz08_grey.png'),
  'imgMedal8': require('../../assets/img/star/xz09_grey.png'),
  'imgMedal9': require('../../assets/img/star/xz10_grey.png')
}


const isDev = process.env.NODE_ENV === 'development';
const OS = common.validateOS(); // 系统
const clientVersion = common.getClientVersion(); // 客户端版本

class Scenes extends React.Component {
  timers = new Map();

  interval = null;
  background = null;
  backParticle = null;
  roomboxComing = null;
  medal = null;
  whiteMeteor = null;
  ballInBottle = new Map();
  backgroundRef = React.createRef();
  backParticleRef = React.createRef();
  roomboxComingRef = React.createRef();
  whiteMeteorRef = React.createRef();
  explodeRef = React.createRef();
  medalRef = React.createRef();
  activeSpanRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      showExchangeBtn: true,
      bottleAniScale: false,
      roomboxShake: false,
      initialize: false,
      curOnceLighted: true, // false没点亮 true点亮
      noLightMedalScale: false,
      ballNumToBottle: 0,
      balance: 0,
      isLandscape: window.matchMedia("(orientation: landscape)").matches,
      activeIndex: 0,
      deviceOs: '',
      xzList: [
        {
          id: 1,
          className: 'xzItem1',
          ballNum: 0,
          onceLighted: false,
          active: true
        },
        {
          id: 2,
          className: 'xzItem2',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 3,
          className: 'xzItem3',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 4,
          className: 'xzItem4',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 5,
          className: 'xzItem5',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 6,
          className: 'xzItem6',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 7,
          className: 'xzItem7',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 8,
          className: 'xzItem8',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 9,
          className: 'xzItem9',
          ballNum: 0,
          onceLighted: false,
          active: false
        },
        {
          id: 10,
          className: 'xzItem10',
          ballNum: 0,
          onceLighted: false,
          active: false
        }
      ],
      game: {
        type: isMobileJs.android.device ? Phaser.CANVAS : Phaser.AUTO,
        width: config.width,
        height: config.height,
        transparent: true,
        scene: {
          preload: function () {
            // Load body shapes from JSON file generated using PhysicsEditor
            this.load.json('shapes', BottleJson);
            // Load sprite sheet generated with TexturePacker
            this.load.atlas('sheet', Img, SpriteJson);
          },
          create: function () {
            let shapes = this.cache.json.get('shapes');
            window.game = this;
            window.shapes = shapes;
            this.matter.world.setBounds(0, 0, config.width, config.height);
            let ground = this.matter.add.sprite(0, 0, 'sheet', 'big-bottle.png', { shape: shapes['big-bottle'] });
            ground.setPosition(105, 143);
            // window.canDrag = this.matter.world.nextGroup(false);
          }
        },
        physics: {
          default: "matter",
          matter: {
            // debug: true
          }
        }
      }
    }
  }

  componentDidMount() {
    document.title = intl.get('STAR_EXCHANGE');
    let params = ''
    try {
      let url = new URL(window.location.href);
      params = new URLSearchParams(url.search);
    } catch (e) {
      console.log('get params error');
    }
    // 获取设备屏幕宽度
    Commun.get('/api/user/star/account').then(res => {
      // const { balance, maximumHolding } = { balance: 500000, maximumHolding: 100000 };
      const { balance, maximumHolding } = res;
      window.sessionStorage.setItem('totalStar', balance);
      let { ballNumToBottle, activeIndex, xzList, isLandscape } = this.state;
      let totalBallNum = parseInt(balance / 100) > 200 ? 200 : parseInt(balance / 100); //不能超过20 * 10球 本地做个二次限制
      //  1个水晶球100个星星，1个罐20个水晶球，一共10个罐
      let ballTotalMax = parseInt(maximumHolding / 100);
      let lightBottleMax = parseInt(ballTotalMax / 20);
      let left = ballTotalMax % 20 === 0 ? 0 : 1;
      let onceLightNum = lightBottleMax + left;
      // 处理后台数据结构生成xzList的item的球数和是否active和需要掉进瓶子里球数（实际只有一个瓶子） 
      xzList.map((item, index) => {
        item.onceLighted = index === 0 ? true : (index + 1 <= onceLightNum); //第一个默认点亮
        if (totalBallNum > 0 && totalBallNum <= 20) {
          item.ballNum = totalBallNum;
          item.active = true;
          activeIndex = index;
          ballNumToBottle = totalBallNum;
          totalBallNum = 0;
        } else if (totalBallNum > 20) {
          item.ballNum = 20;
          item.active = false;
          totalBallNum -= 20;
        }
      })
      this.setState({
        activeIndex,
        xzList,
        ballNumToBottle,
        balance,
        deviceOs: params.get('device_os')
      }, () => {
        this.init();
        this.calcActiveTab();
      })
    })

    window.addEventListener('resize', this.calcActiveTab);
  }

  componentWillUnmount() {
    this.destroyBottle();
    this.interval && clearInterval(this.interval);
    this.interval = null;
    this.background && this.background.destroy();
    this.background = null;
    this.backParticle && this.backParticle.destroy()
    this.backParticle = null;
    this.whiteMeteor && this.whiteMeteor.destroy();
    this.whiteMeteor = null;
    this.roomboxComing && this.roomboxComing.destroy();
    this.roomboxComing = null;
    this.explode&&this.explode.destroy();
    this.explode = null;
    window.removeEventListener('resize', this.calcActiveTab);
  }


  calcActiveTab = () => {
    const c = this.activeSpanRef.current;
    const a = document.querySelector('.activeXzItem');
    const cw = c.offsetWidth;
    const aw = a.offsetWidth;
    const ol = a.offsetLeft;
    c.style.left = (ol - (cw - aw) / 2) + 'px';
    this.setState({
      isLandscape: window.matchMedia("(orientation: landscape)").matches
    })
  }

  init = () => {
    // 背景
    this.background = lottie.loadAnimation({
      container: this.backgroundRef.current,
      renderer: 'canvas',
      name: 'background',
      loop: false,
      autoplay: true,
      animationData: backgroundJson
    });

    this.background.addEventListener('complete', e => {
      // 微粒子
      this.backParticle = lottie.loadAnimation({
        container: this.backParticleRef.current,
        renderer: 'canvas',
        name: 'backParticle',
        loop: true,
        autoplay: true,
        animationData: backParticleJson
      });

      // 流星
      this.whiteMeteor = lottie.loadAnimation({
        container: this.whiteMeteorRef.current,
        renderer: 'canvas',
        name: 'whiteMeteor',
        loop: false,
        autoplay: true,
        animationData: whiteMeteorJson
      });
      this.interval = setInterval(() => {
        this.whiteMeteor.goToAndPlay(0);
      }, 5000);


      // 小人飞船roomboxComing
      this.roomboxComing = lottie.loadAnimation({
        container: this.roomboxComingRef.current,
        renderer: 'canvas',
        name: 'roomboxComing',
        loop: false,
        autoplay: true,
        animationData: roomboxComingJson
      });

      this.roomboxComing.addEventListener('complete', e => {
        this.setState({
          initialize: true,
          roomboxShake: true
        }, () => {
          this.performExplodeAndMedal(true);
        })
      });
    })
  }


  destroyBottle = () => {
    // 清空球
    for (let value of this.ballInBottle.values()) {
      value && value.destroy();
    }
    this.ballInBottle = new Map();
  }

  /**
   * @description:
   * @param {boolean}  init代表是否初始化第一次进页面
   * @return:
   */
  performExplodeAndMedal = (init) => {
    const { activeIndex, xzList } = this.state;
    const isLighted = xzList[activeIndex].onceLighted;
    if (init) {
      if (isLighted) {
        this.medalLightAni();
      } else {
        this.setState({
          curOnceLighted: false,
          noLightMedalScale: true
        }, () => {
          this.timers.set(Symbol(), setTimeout(() => {
            this.setState({
              noLightMedalScale: false
            })
            this.addBall(this.state.ballNumToBottle);
          }, 500))
        })
      }
    } else {
      if (isLighted) {
        this.setState({
          bottleAniScale: true
        }, () => {
          this.timers.set(Symbol(), setTimeout(() => {
            this.setState({
              bottleAniScale: false
            })
            this.medalLightAni();
          }, 1000))
        })
      } else {
        this.setState({
          bottleAniScale: true
        }, () => {
          this.timers.set(Symbol(), setTimeout(() => {
            this.setState({
              bottleAniScale: false,
              curOnceLighted: false,
              noLightMedalScale: true
            }, () => {
              this.timers.set(Symbol(), setTimeout(() => {
                this.setState({
                  noLightMedalScale: false
                })
                this.addBall(this.state.ballNumToBottle);
              }, 500))
            })
          }, 100))
        })
      }
    }
  }

  medalLightAni = () => {
    if (this.explode) {
      this.explode.goToAndPlay(0);
    }
    // 爆炸
    if (!this.explode) {
      // this.explode = lottie.loadAnimation({
      //   container: this.explodeRef.current,
      //   renderer: 'canvas',
      //   name: 'explode',
      //   loop: false,
      //   autoplay: true,
      //   animationData: explodeJson
      // });
    }

    // this.explode.addEventListener('enterFrame', e => {}) 不能用这个，否则切换时没勋章，但是监听到了还有勋章没法清除
    this.timers.set(Symbol(), setTimeout(() => {
      if (!this.medal) {
        // 勋章
        this.medal = lottie.loadAnimation({
          container: this.medalRef.current,
          renderer: 'canvas',
          name: 'medal',
          loop: false,
          autoplay: true,
          animationData: config[this.state.activeIndex]
        });
        this.medal.addEventListener('complete', e => {
          // this.state.onceLighted && this.addBall(this.state.ballNumToBottle);
          this.addBall(this.state.ballNumToBottle);
          // this.explode && this.addBall(this.state.ballNumToBottle);
        })
      }
    }, 500))
  }

  tabXz = throttle((item, index) => {
    // 爆炸一定不能销毁！！会爆浏览器内存(010) 勋章销毁(01) 但两者容器元素一直在
    if (item.active) return;

    for (let value of this.timers.values()) {
      value && clearTimeout(value);
    }
    this.timers = new Map();
    this.destroyBottle();
    this.medal && this.medal.destroy();
    this.medal = null;
    const beforeActiveItem = document.querySelector('.activeXzItem');
    const { xzList } = this.state;
    xzList.map(t => {
      t.active = false;
    });
    xzList[index].active = true;
    this.setState({
      ballNumToBottle: xzList[index].ballNum,
      activeIndex: index,
      xzList: xzList,
      curOnceLighted: true
    }, () => {
      this.performExplodeAndMedal(false);
      this.calcActiveTab();
      this.beforeAni(beforeActiveItem);
    })
  }, 500)

  beforeAni = (dom) => {
    dom.classList.add('beforeActive');
    dom.onanimationend = () => {
      dom.classList.remove('beforeActive');
    };
  }

  addBall = (num) => {
    const ts = config['ball' + this.state.activeIndex];
    [...Array(num)].map(() => {
      // 暂时定的规则出发点（105, 143）:: x:100到115 y:70 到90
      let sprite = window.game?.matter?.add?.sprite(Math.random() * 15 + 100, Math.random() * 20 + 70, 'sheet', ts + '.png', { shape: window.game.cache.json.get('shapes')[ts] });
      sprite && sprite.setScale(.5);
      // sprite.setCollisionGroup(window.canDrag);
      // sprite.setInteractive({ draggable: true });
      // window.game.matter.add.mouseSpring({ length: 1, stiffness: 0.6, collisionFilter: { group: window.canDrag } });
      let s = Symbol();
      this.ballInBottle.set(s, sprite);
    });
  }

  tabPage = (type) => {
    const { showDynamic } = this.props;
    if (!isMobile) {
      if (type === 1) {
        showDynamic && showDynamic({ starInstructionShow: true, starListShow: false });
      }
      if (type === 2) {
        showDynamic && showDynamic({ starListShow: true, starInstructionShow: false });
      }
    } else {
      if (type === 1) {
        this.props.history.push({ pathname: '/m/starInstruction', search: window.location.search });
      }
      if (type === 2) {
        this.props.history.push({ pathname: '/m/starList', search: window.location.search });
      }
    }
  }

  showExchange = () => {
    const { showDynamic } = this.props;
    if (!isMobile) {
      showDynamic && showDynamic({ exchangeModalShow: true });
    } else {
      this.props.history.push({
        pathname: '/exchange',
        search: window.location.search
      });
    }
  }

  onSwipe = (e) => {
    const { direction } = e;
    let { xzList, activeIndex } = this.state;
    if (direction === 'Right') {
      activeIndex = activeIndex === 0 ? (xzList.length - 1) : (activeIndex - 1);
    }
    if (direction === 'Left') {
      activeIndex = activeIndex === xzList.length - 1 ? 0 : (activeIndex + 1);
    }
    this.tabXz(xzList[activeIndex], activeIndex);
  }


  render() {
    const { showExchangeBtn, initialize, game, bottleAniScale, noLightMedalScale, curOnceLighted, roomboxShake, xzList, activeIndex, ballNumToBottle, balance, isLandscape, deviceOs } = this.state;
    return (
      <div className={`${styles.scenes} light-scroll-bar ${styles[(isMobileJs.apple.tablet || (isMobileJs.tablet && isLandscape) || deviceOs === 'AndroidPad' ) ? 'tablet' : '']}`}>
          <div className={styles.scenesWrap}>
            <AlloyFinger
                onSwipe={(e) => this.onSwipe(e)}
            >
              <div className={styles.bottleContainer}>
                <div className={styles.whiteMeteor} ref={this.whiteMeteorRef} ></div>
                <div className={styles.background} ref={this.backgroundRef}></div>
                <div className={styles.ball1}></div>
                <div className={styles.ball2}></div>
                <div className={`${styles.roomboxComing} ${roomboxShake ? styles.roomboxShake : ''}`} ref={this.roomboxComingRef}></div>
                <div className={styles.backParticle} ref={this.backParticleRef}></div>

                <div className={styles.bottleWrap}>
                  <div className={`${styles.bottleBox} ${bottleAniScale ? styles.bottleAniScale : ''}`} style={{ width: config.width, height: config.height }}>
                    <IonPhaser game={game} initialize={initialize} />
                    <div className={styles.explode} ref={this.explodeRef}></div>
                    <div className={styles.medal} ref={this.medalRef}></div>
                    {!curOnceLighted && <div style={{ backgroundImage: `url(${config['imgMedal' + activeIndex]})` }} className={`${styles.noLightMedal} ${styles['noLightMedal' + (activeIndex + 1)]} ${noLightMedalScale ? styles.noLightMedalScale : ''}`}></div>}
                  </div>
                </div>
              </div>
            </AlloyFinger>
            <div className={styles.messageCon}>
              {
                xzList[activeIndex].onceLighted ?
                    <>
                      <div className={styles.mesLeft}>
                        <span className={styles.ownText}>拥有</span><span className={styles.numInBottle}>{ballNumToBottle}</span><i className={styles.curBall} style={{ backgroundImage: `url(${config['imgBall' + activeIndex]})` }}></i>
                      </div>
                      <div className={styles.mesRight}>
                        <span className={styles.hundred}>100</span><i className={styles.stars}></i><span>=</span><span className={styles.one}>1</span><i className={styles.curBall} style={{ backgroundImage: `url(${config['imgBall' + activeIndex]})` }}></i>
                      </div>
                    </>
                    :
                    <p>{'这个勋章还未点亮，加油哟  <(▰˘◡˘▰)>'}</p>
              }
            </div>
            {
              !isMobile &&
              <div className={styles.totalStarCon}>
                <div className={styles.left}>
                  <img src={require('../../assets/img/star/star_total.png')} width="48" height="48" />
                  <div className={styles.totalStarDesc}>
                    <p className={styles.totalStarDescText}>星星总量</p>
                    <p className={styles.totalStarDescNum}>{balance}</p>
                  </div>
                </div><ul className={styles.right}>
                <li>
                  <span className={styles.regularBtn} onClick={() => { this.tabPage(1) }}>星星规则</span>
                </li>
                <li>
                  <span className={styles.starDetailBtn} onClick={() => { this.tabPage(2) }}>星星明细</span>
                </li>
                {
                  showExchangeBtn &&
                  <>
                    {
                      <li><Button type="primary" onClick={this.showExchange}>星星兑换</Button></li>
                    }
                  </>
                }
              </ul>
              </div>
            }
            {
              isMobile &&
              <div className={styles.mobileTotalStar}>
                <div className={styles.mobileTotalWrap}>
                  <div className={styles.totalStarIcon}/>
                  <div className={styles.totalStar}>
                    <p className={styles.totalLabel}>星星总量</p>
                    <p className={styles.totalCount}>{balance}</p>
                  </div>
                  {
                    showExchangeBtn &&
                    <>
                      <div className={styles.exchangeBtn} onClick={this.showExchange}>
                        <i className={styles.exchangeBtnIcon}/>
                        <label className={styles.exchangeBtnLabel}>星星兑换</label>
                      </div>
                    </>
                  }
                </div>
              </div>
            }
          </div>
          {
            isMobile &&
            <ul className={styles.mobileRightEntries}>
              <li>
                <div className={`${styles.entryIcon} ${styles.strategyIcon}`} onClick={() => this.tabPage(1)}/>
              </li>
              <li>
                <div className={`${styles.entryIcon} ${styles.detailIcon}`} onClick={() => this.tabPage(2)}/>
              </li>
            </ul>
          }
          <div className={styles.xzCon}>
            {
              isMobile && <div className={styles.mobileShadow}></div>
            }
            <ul className={styles.xzList}>
              {
                xzList.map((item, index) => (
                    <li
                        key={item.id}
                        className={`${styles.xzItem} ${styles[item.className]} ${item.active ? styles.active : ''} ${item.active ? 'activeXzItem' : 'xzItem'} ${item.onceLighted ? styles.onceLighted : ''} `}
                        onClick={() => this.tabXz(item, index)}
                    >
                    </li>

                ))
              }
              <span ref={this.activeSpanRef} className={styles.activeSpan}></span>
            </ul>
          </div>
        </div>
    )
  }
}

export default withRouter(Scenes);